export const automobileProducts = [
  {
      "productId": "10774cb5f43646d888a4c702c9f19b5d",
      "name": "Organic Sesame Oil/ Gingelly Oil - 500 ml - cold pressed",
      "pic": "https://storage.googleapis.com/bo3151920215/business/186492f9a0fa41e29ab17dcc0ab3ba7f/product/10774cb5f43646d888a4c702c9f19b5d/Product2-742574.jpeg",
      "totalQuantity": 1,
      "item": {
          "id": "10774cb5f43646d888a4c702c9f19b5d",
          "productName": "Organic Sesame Oil/ Gingelly Oil - 500 ml - cold pressed",
          "productDescription": "Best suited for daily cooking. \n\n* Contains sesamol, which helps in absorption of vitamin E. Sesamol is also an effective anti-oxidant and anti-fungal. \n\n* Sesame oil is rich in Vitamin B 12 & Vitamin B 6\n\n* Prevents diabetes and helps lower blood pressure\n\n* Lowers stress and depression\n\n* Natural cure for anaemia\n\n* Helps in skin detoxification and good for body massages\n\n* Treat premature greying of hair\n\nIndustrial Extraction Vs Cold Pressed Oils\nExtraction by industrial methods, involves various processes like bleaching, steaming, distillation and hydrogenation - the seeds are exposed to extremely high temperatures to get clear bland oil and  chemicals like phosphoric acid, calcium hypo chlorite are added to increase the shelf life of the product which in turn affects  not only the flavour and aroma but also strips the oil of all its nutritive values. The more refined an oil is the less nourishing it will be for our bodies.\n\nNo heat or minimal heat was used for crushing/pressing the seeds and the process of production was simple without the addition of any solvent. The end product, thereby was qualitative with nutrients intact - making it ideal for cooking. A surefire way to do this right, would be to go the local, non-blended and chemical free route. And if this seems liked a lot of work- ask your grandmother! What they have been traditionally consuming before all the modernisation is the ideal choice.",
          "catalogType": "Product",
          "searchText": null,
          "productSearch": "organicsesameoilgingellyoil500mlcoldpressed",
          "currencySymbol": "₹",
          "status": "active",
          "unitOfMeasure": "Ltr",
          "commerceEnabled": "YES",
          "brand": "",
          "origin": "India",
          "categoryPath": "",
          "categoryCodePath": "",
          "hyperLocal": null,
          "businessResellerFlag": "y",
          "costboHsnCode": null,
          "offer": null,
          "preference": 8,
          "productOriginalPrice": 215.0,
          "productSalePrice": 215.0,
          "percentageOff": 0.0,
          "minOrderQuantity": 1.0,
          "maxOrderQuantity": 10.0,
          "availableQuantity": 249.0,
          "soldQuantity": 2.0,
          "alertQuantity": 25.0,
          "shipmentDistance": 4000.0,
          "commerceStartDate": 1561833000000,
          "commerceEndDate": 1672425000000
      },
      "createdDate": 1606575264672
  },
  {
      "productId": "15389c366dee47d88fc4c48ecdcc6e23",
      "name": "Organic Sesame Oil/ Gingelly Oil - Cold pressed - 2  litre",
      "pic": "https://storage.googleapis.com/bo3151920215/business/186492f9a0fa41e29ab17dcc0ab3ba7f/product/15389c366dee47d88fc4c48ecdcc6e23/product1-ipIuGQ.jpeg",
      "totalQuantity": 6,
      "item": {
          "id": "15389c366dee47d88fc4c48ecdcc6e23",
          "productName": "Organic Sesame Oil/ Gingelly Oil - Cold pressed - 2  litre",
          "productDescription": "Best suited for daily cooking. \n\n* Contains sesamol, which helps in absorption of vitamin E. Sesamol is also an effective anti-oxidant and anti-fungal. \n\n* Sesame oil is rich in Vitamin B 12 & Vitamin B 6\n\n* Prevents diabetes and helps lower blood pressure\n\n* Lowers stress and depression\n\n* Natural cure for anaemia\n\n* Helps in skin detoxification and good for body massages\n\n* Treat premature greying of hair\n\nIndustrial Extraction Vs Cold Pressed Oils\nExtraction by industrial methods, involves various processes like bleaching, steaming, distillation and hydrogenation - the seeds are exposed to extremely high temperatures to get clear bland oil and  chemicals like phosphoric acid, calcium hypo chlorite are added to increase the shelf life of the product which in turn affects  not only the flavour and aroma but also strips the oil of all its nutritive values. The more refined an oil is the less nourishing it will be for our bodies.\n\nNo heat or minimal heat was used for crushing/pressing the seeds and the process of production was simple without the addition of any solvent. The end product, thereby was qualitative with nutrients intact - making it ideal for cooking. A surefire way to do this right, would be to go the local, non-blended and chemical free route. And if this seems liked a lot of work- ask your grandmother! What they have been traditionally consuming before all the modernisation is the ideal choice.",
          "catalogType": "Product",
          "searchText": null,
          "productSearch": "organicsesameoilgingellyoilcoldpressed2litre",
          "currencySymbol": "₹",
          "status": "active",
          "unitOfMeasure": "Ltr",
          "commerceEnabled": "YES",
          "brand": "",
          "origin": "India",
          "categoryPath": "",
          "categoryCodePath": "",
          "hyperLocal": null,
          "businessResellerFlag": "y",
          "costboHsnCode": null,
          "offer": null,
          "preference": 10,
          "productOriginalPrice": 900.0,
          "productSalePrice": 820.0,
          "percentageOff": 9.0,
          "minOrderQuantity": 1.0,
          "maxOrderQuantity": 10.0,
          "availableQuantity": 247.0,
          "soldQuantity": 3.0,
          "alertQuantity": 25.0,
          "shipmentDistance": 4000.0,
          "commerceStartDate": 1561833000000,
          "commerceEndDate": 1672425000000
      },
      "createdDate": 1636438947693
  },
  {
      "productId": "2e8c8ce924674a9094876206576d049e",
      "name": "Jaggery Sugar Cane (Organic) - 500 grams",
      "pic": "https://storage.googleapis.com/bo3151920215/business/186492f9a0fa41e29ab17dcc0ab3ba7f/product/2e8c8ce924674a9094876206576d049e/Product3-434274.JPG",
      "totalQuantity": 5,
      "item": {
          "id": "2e8c8ce924674a9094876206576d049e",
          "productName": "Jaggery Sugar Cane (Organic) - 500 grams",
          "productDescription": "Healthy alternative to ordinary sugar for sweetening, cooking and baking, you are going to love our naturally delicious, mineral-rich, certified organic jaggery. It’s made from the extracted juice of organically grown sugarcane, produced to form a gorgeous, rich, healthy sweetener that has been used in traditional diets in India.",
          "catalogType": "Product",
          "searchText": null,
          "productSearch": "jaggerysugarcaneorganic500grams",
          "currencySymbol": "₹",
          "status": "active",
          "unitOfMeasure": "Gram",
          "commerceEnabled": "YES",
          "brand": "",
          "origin": "India",
          "categoryPath": "",
          "categoryCodePath": "",
          "hyperLocal": null,
          "businessResellerFlag": "y",
          "costboHsnCode": null,
          "offer": null,
          "preference": 23,
          "productOriginalPrice": 60.0,
          "productSalePrice": 55.0,
          "percentageOff": 8.0,
          "minOrderQuantity": 1.0,
          "maxOrderQuantity": 10.0,
          "availableQuantity": 699.0,
          "soldQuantity": 9241.0,
          "alertQuantity": 25.0,
          "shipmentDistance": 4000.0,
          "commerceStartDate": 1561833000000,
          "commerceEndDate": 1672425000000
      },
      "createdDate": 1618744511272
  },
  {
      "productId": "4ba12a7c20f24753bf315f25e409283a",
      "name": "Kodubale - 150 grams",
      "pic": "https://storage.googleapis.com/bo3151920215/business/186492f9a0fa41e29ab17dcc0ab3ba7f/product/4ba12a7c20f24753bf315f25e409283a/Product0-856151.jpg",
      "totalQuantity": 1,
      "item": {
          "id": "4ba12a7c20f24753bf315f25e409283a",
          "productName": "Kodubale - 150 grams",
          "productDescription": "Made with Organic rice flour. No colours added. No preservatives.",
          "catalogType": "Product",
          "searchText": "",
          "productSearch": "kodubale150grams",
          "currencySymbol": "₹",
          "status": "active",
          "unitOfMeasure": "Gram",
          "commerceEnabled": "YES",
          "brand": "Divyams",
          "origin": "India",
          "categoryPath": "",
          "categoryCodePath": "",
          "hyperLocal": null,
          "businessResellerFlag": "y",
          "costboHsnCode": null,
          "offer": null,
          "preference": 0,
          "productOriginalPrice": 60.0,
          "productSalePrice": 60.0,
          "percentageOff": 0.0,
          "minOrderQuantity": 1.0,
          "maxOrderQuantity": 10.0,
          "availableQuantity": 248.0,
          "soldQuantity": 2.0,
          "alertQuantity": 25.0,
          "shipmentDistance": 4000.0,
          "commerceStartDate": 1561833000000,
          "commerceEndDate": 1672425000000
      },
      "createdDate": 1606575264672
  },
  {
      "productId": "a1b06f8177194a538f521608bbb1c8bb",
      "name": "Organic Sesame Oil/ Gingelly Oil - Cold pressed - 1 litre",
      "pic": "https://storage.googleapis.com/bo3151920215/business/186492f9a0fa41e29ab17dcc0ab3ba7f/product/a1b06f8177194a538f521608bbb1c8bb/product1-K8bhK9.jpeg",
      "totalQuantity": 17,
      "item": {
          "id": "a1b06f8177194a538f521608bbb1c8bb",
          "productName": "Organic Sesame Oil/ Gingelly Oil - Cold pressed - 1 litre",
          "productDescription": "Best suited for daily cooking. \n\n* Contains sesamol, which helps in absorption of vitamin E. Sesamol is also an effective anti-oxidant and anti-fungal. \n\n* Sesame oil is rich in Vitamin B 12 & Vitamin B 6\n\n* Prevents diabetes and helps lower blood pressure\n\n* Lowers stress and depression\n\n* Natural cure for anaemia\n\n* Helps in skin detoxification and good for body massages\n\n* Treat premature greying of hair\n\nIndustrial Extraction Vs Cold Pressed Oils\nExtraction by industrial methods, involves various processes like bleaching, steaming, distillation and hydrogenation - the seeds are exposed to extremely high temperatures to get clear bland oil and  chemicals like phosphoric acid, calcium hypo chlorite are added to increase the shelf life of the product which in turn affects  not only the flavour and aroma but also strips the oil of all its nutritive values. The more refined an oil is the less nourishing it will be for our bodies.\n\nNo heat or minimal heat was used for crushing/pressing the seeds and the process of production was simple without the addition of any solvent. The end product, thereby was qualitative with nutrients intact - making it ideal for cooking. A surefire way to do this right, would be to go the local, non-blended and chemical free route. And if this seems liked a lot of work- ask your grandmother! What they have been traditionally consuming before all the modernisation is the ideal choice.",
          "catalogType": "Product",
          "searchText": null,
          "productSearch": "organicsesameoilgingellyoilcoldpressed1litre",
          "currencySymbol": "₹",
          "status": "active",
          "unitOfMeasure": "Ltr",
          "commerceEnabled": "YES",
          "brand": "",
          "origin": "India",
          "categoryPath": "",
          "categoryCodePath": "",
          "hyperLocal": null,
          "businessResellerFlag": "y",
          "costboHsnCode": null,
          "offer": null,
          "preference": 9,
          "productOriginalPrice": 450.0,
          "productSalePrice": 425.0,
          "percentageOff": 6.0,
          "minOrderQuantity": 1.0,
          "maxOrderQuantity": 10.0,
          "availableQuantity": 235.0,
          "soldQuantity": 15.0,
          "alertQuantity": 25.0,
          "shipmentDistance": 4000.0,
          "commerceStartDate": 1561833000000,
          "commerceEndDate": 1672425000000
      },
      "createdDate": 1646984938299
  },
  {
      "productId": "b043244c5a1b473c89e914f3d057ed9c",
      "name": "Natural Tamarind 800g",
      "pic": "https://storage.googleapis.com/bo3151920215/business/186492f9a0fa41e29ab17dcc0ab3ba7f/product/b043244c5a1b473c89e914f3d057ed9c/Product2-593931.jpeg",
      "totalQuantity": 1,
      "item": {
          "id": "b043244c5a1b473c89e914f3d057ed9c",
          "productName": "Natural Tamarind 800g",
          "productDescription": "Natural Tamarind 800g",
          "catalogType": "Product",
          "searchText": "",
          "productSearch": "naturaltamarind800g",
          "currencySymbol": "₹",
          "status": "active",
          "unitOfMeasure": "Gram",
          "commerceEnabled": "YES",
          "brand": "Cape Comorian",
          "origin": "India",
          "categoryPath": "",
          "categoryCodePath": "",
          "hyperLocal": null,
          "businessResellerFlag": "y",
          "costboHsnCode": null,
          "offer": null,
          "preference": 28,
          "productOriginalPrice": 209.0,
          "productSalePrice": 209.0,
          "percentageOff": 0.0,
          "minOrderQuantity": 1.0,
          "maxOrderQuantity": 5.0,
          "availableQuantity": 250.0,
          "soldQuantity": 0.0,
          "alertQuantity": 20.0,
          "shipmentDistance": 4000.0,
          "commerceStartDate": 1605810600000,
          "commerceEndDate": 1668882600000
      },
      "createdDate": 1606575264672
  },
  {
      "productId": "b15edf772f1f460ca3440ec1822ca9bb",
      "name": "Organic Coconut Oil - Cold pressed - 500 ml",
      "pic": "https://storage.googleapis.com/bo3151920215/business/186492f9a0fa41e29ab17dcc0ab3ba7f/product/b15edf772f1f460ca3440ec1822ca9bb/Product4-534959.jpeg",
      "totalQuantity": 1,
      "item": {
          "id": "b15edf772f1f460ca3440ec1822ca9bb",
          "productName": "Organic Coconut Oil - Cold pressed - 500 ml",
          "productDescription": "Ideal for seasoning gravies and chutneys.\n\nBenefits\n\n* Increases fat burn, particularly abdominal fat and aids in weight loss\n\n* Rich in Cocositol that helps prevent memory deficiency, Alzheimer’s & Parkinson’s \n\n* Raises HDL or good cholesterol in blood which reduces heart disease\n\n* Rich source of lauric acid which kills bacteria, virus and fungi\n\n* Application on body prevents hair damage and improves moisture content of skin\n \nIndustrial Extraction Vs Cold Pressed Oils\nExtraction by industrial methods, involves various processes like bleaching, steaming, distillation and hydrogenation - the seeds are exposed to extremely high temperatures to get clear bland oil and  chemicals like phosphoric acid, calcium hypo chlorite are added to increase the shelf life of the product which in turn affects  not only the flavour and aroma but also strips the oil of all its nutritive values. The more refined an oil is the less nourishing it will be for our bodies.\n\nNo heat or minimal heat was used for crushing/pressing the seeds and the process of production was simple without the addition of any solvent. The end product, thereby was qualitative with nutrients intact - making it ideal for cooking. A surefire way to do this right, would be to go the local, non-blended and chemical free route. And if this seems liked a lot of work- ask your grandmother! What they have been traditionally consuming before all the modernisation is the ideal choice.",
          "catalogType": "Product",
          "searchText": null,
          "productSearch": "organiccoconutoilcoldpressed500ml",
          "currencySymbol": "₹",
          "status": "active",
          "unitOfMeasure": "Ltr",
          "commerceEnabled": "YES",
          "brand": "",
          "origin": "India",
          "categoryPath": "",
          "categoryCodePath": "",
          "hyperLocal": null,
          "businessResellerFlag": "y",
          "costboHsnCode": null,
          "offer": null,
          "preference": 4,
          "productOriginalPrice": 230.0,
          "productSalePrice": 210.0,
          "percentageOff": 9.0,
          "minOrderQuantity": 1.0,
          "maxOrderQuantity": 10.0,
          "availableQuantity": 245.0,
          "soldQuantity": 5.0,
          "alertQuantity": 25.0,
          "shipmentDistance": 4000.0,
          "commerceStartDate": 1617561000000,
          "commerceEndDate": 1756578600000
      },
      "createdDate": 1616937534253
  },
  {
      "productId": "b184b1e6503b4be09a346976da9d4f2b",
      "name": "Organic Castor Oil - Cold pressed - 1 litre",
      "pic": "https://storage.googleapis.com/bo3151920215/business/186492f9a0fa41e29ab17dcc0ab3ba7f/product/b184b1e6503b4be09a346976da9d4f2b/Product1-211985.jpeg",
      "totalQuantity": 2,
      "item": {
          "id": "b184b1e6503b4be09a346976da9d4f2b",
          "productName": "Organic Castor Oil - Cold pressed - 1 litre",
          "productDescription": "Perhaps one of the best-known medicinal uses for castor oil is as a natural laxative. It’s classified as a stimulant laxative, meaning that it increases the movement of the muscles that push material through the intestines, helping clear the bowels.\n\nWhile castor oil is considered safe in small doses, larger amounts can cause abdominal cramping, nausea, vomiting and diarrhea.\n\nCastor oil is often used in cosmetics to promote hydration and often added to products like lotions, makeup and cleansers.\n\nCastor oil on its own as a natural alternative to store-bought moisturisers and lotions. Castor oil is thick, so it’s frequently mixed with other skin-friendly oils like almond, olive and coconut oil to make an ultra-hydrating moisturizer.\n\nCastor oil helps fight inflammation, reduce bacteria and soothe irritated skin, all of which can be helpful for those looking for a natural acne remedy.\n\nThe moisturizing and anti-inflammatory properties of castor oil make it an excellent option to keep hair soft and hydrated and help reduce dandruff symptoms.\n\nIndustrial Extraction Vs Cold Pressed Oils\nExtraction by industrial methods, involves various processes like bleaching, steaming, distillation and hydrogenation - the seeds are exposed to extremely high temperatures to get clear bland oil and  chemicals like phosphoric acid, calcium hypo chlorite are added to increase the shelf life of the product which in turn affects  not only the flavour and aroma but also strips the oil of all its nutritive values. The more refined an oil is the less nourishing it will be for our bodies.\n\nNo heat or minimal heat was used for crushing/pressing the seeds and the process of production was simple without the addition of any solvent. The end product, thereby was qualitative with nutrients intact - making it ideal for cooking. A surefire way to do this right, would be to go the local, non-blended and chemical free route. And if this seems liked a lot of work- ask your grandmother! What they have been traditionally consuming before all the modernisation is the ideal choice.",
          "catalogType": "Product",
          "searchText": null,
          "productSearch": "organiccastoroilcoldpressed1litre",
          "currencySymbol": "₹",
          "status": "active",
          "unitOfMeasure": "Ltr",
          "commerceEnabled": "YES",
          "brand": "",
          "origin": "India",
          "categoryPath": "",
          "categoryCodePath": "",
          "hyperLocal": null,
          "businessResellerFlag": "y",
          "costboHsnCode": null,
          "offer": null,
          "preference": 15,
          "productOriginalPrice": 375.0,
          "productSalePrice": 350.0,
          "percentageOff": 7.0,
          "minOrderQuantity": 1.0,
          "maxOrderQuantity": 10.0,
          "availableQuantity": 250.0,
          "soldQuantity": 0.0,
          "alertQuantity": 25.0,
          "shipmentDistance": 4000.0,
          "commerceStartDate": 1613932200000,
          "commerceEndDate": 1672425000000
      },
      "createdDate": 1602684068753
  },
  {
      "productId": "b696e20e441042cf893b09d07a889838",
      "name": "Organic Cocount Oil - Cold pressed - 1 litre",
      "pic": "https://storage.googleapis.com/bo3151920215/business/186492f9a0fa41e29ab17dcc0ab3ba7f/product/b696e20e441042cf893b09d07a889838/product1-lE7wkc.jpeg",
      "totalQuantity": 5,
      "item": {
          "id": "b696e20e441042cf893b09d07a889838",
          "productName": "Organic Cocount Oil - Cold pressed - 1 litre",
          "productDescription": "Ideal for seasoning gravies and chutneys.\n\nBenefits\n\n* Increases fat burn, particularly abdominal fat and aids in weight loss\n\n* Rich in Cocositol that helps prevent memory deficiency, Alzheimer’s & Parkinson’s \n\n* Raises HDL or good cholesterol in blood which reduces heart disease\n\n* Rich source of lauric acid which kills bacteria, virus and fungi\n\n* Application on body prevents hair damage and improves moisture content of skin\n \nIndustrial Extraction Vs Cold Pressed Oils\nExtraction by industrial methods, involves various processes like bleaching, steaming, distillation and hydrogenation - the seeds are exposed to extremely high temperatures to get clear bland oil and  chemicals like phosphoric acid, calcium hypo chlorite are added to increase the shelf life of the product which in turn affects  not only the flavour and aroma but also strips the oil of all its nutritive values. The more refined an oil is the less nourishing it will be for our bodies.\n\nNo heat or minimal heat was used for crushing/pressing the seeds and the process of production was simple without the addition of any solvent. The end product, thereby was qualitative with nutrients intact - making it ideal for cooking. A surefire way to do this right, would be to go the local, non-blended and chemical free route. And if this seems liked a lot of work- ask your grandmother! What they have been traditionally consuming before all the modernisation is the ideal choice.",
          "catalogType": "Product",
          "searchText": null,
          "productSearch": "organiccocountoilcoldpressed1litre",
          "currencySymbol": "₹",
          "status": "active",
          "unitOfMeasure": "Ltr",
          "commerceEnabled": "YES",
          "brand": "",
          "origin": "India",
          "categoryPath": "",
          "categoryCodePath": "",
          "hyperLocal": null,
          "businessResellerFlag": "y",
          "costboHsnCode": null,
          "offer": null,
          "preference": 5,
          "productOriginalPrice": 410.0,
          "productSalePrice": 390.0,
          "percentageOff": 5.0,
          "minOrderQuantity": 1.0,
          "maxOrderQuantity": 10.0,
          "availableQuantity": 231.0,
          "soldQuantity": 21.0,
          "alertQuantity": 25.0,
          "shipmentDistance": 4000.0,
          "commerceStartDate": 1625250600000,
          "commerceEndDate": 1756578600000
      },
      "createdDate": 1646984938299
  },
  {
      "productId": "d1347cafbd814b419ac5ec9f44db5b21",
      "name": "Groundnut Burfi/ Kadala Mittai - 250 grams",
      "pic": "https://storage.googleapis.com/bo3151920215/business/186492f9a0fa41e29ab17dcc0ab3ba7f/product/d1347cafbd814b419ac5ec9f44db5b21/Product4-259571.JPG",
      "totalQuantity": 6,
      "item": {
          "id": "d1347cafbd814b419ac5ec9f44db5b21",
          "productName": "Groundnut Burfi/ Kadala Mittai - 250 grams",
          "productDescription": "Kovilpatti Kadalai Mittai made from good quality Roasted peanuts & jaggery . Yummy and tasty kadalai mittai made in famous south Indian city kovilpatti",
          "catalogType": "Product",
          "searchText": null,
          "productSearch": "groundnutburfikadalamittai250grams",
          "currencySymbol": "₹",
          "status": "active",
          "unitOfMeasure": "Gram",
          "commerceEnabled": "YES",
          "brand": "",
          "origin": "India",
          "categoryPath": "",
          "categoryCodePath": "",
          "hyperLocal": null,
          "businessResellerFlag": "y",
          "costboHsnCode": null,
          "offer": null,
          "preference": 0,
          "productOriginalPrice": 120.0,
          "productSalePrice": 110.0,
          "percentageOff": 8.0,
          "minOrderQuantity": 1.0,
          "maxOrderQuantity": 10.0,
          "availableQuantity": 247.0,
          "soldQuantity": 3.0,
          "alertQuantity": 25.0,
          "shipmentDistance": 4000.0,
          "commerceStartDate": 1561833000000,
          "commerceEndDate": 1672425000000
      },
      "createdDate": 1636438947693
  },
  {
      "productId": "e4fb05ebe6764a4b8149a3c33383debb",
      "name": "Organic Groundnut Oil - Cold pressed - 1 litre",
      "pic": "https://storage.googleapis.com/bo3151920215/business/186492f9a0fa41e29ab17dcc0ab3ba7f/product/e4fb05ebe6764a4b8149a3c33383debb/product1-2RdJmD.jpeg",
      "totalQuantity": 11,
      "item": {
          "id": "e4fb05ebe6764a4b8149a3c33383debb",
          "productName": "Organic Groundnut Oil - Cold pressed - 1 litre",
          "productDescription": "Best suited for daily cooking. \n\nMade from sun dried ground nuts, good source of plant sterols.\n\n* Cold pressed groundnut oil is rich in MUFA. It is free of trans fat. \n\n* Improves heart health\n\n* Rich in antioxidants, thereby protecting against cancer\n\n* Improves blood flow\n\n* Helps lowering high blood pressure\n\n* Help get rid of acne and blackheads\n\n\nIndustrial Extraction Vs Cold Pressed Oils\nExtraction by industrial methods, involves various processes like bleaching, steaming, distillation and hydrogenation - the seeds are exposed to extremely high temperatures to get clear bland oil and  chemicals like phosphoric acid, calcium hypo chlorite are added to increase the shelf life of the product which in turn affects  not only the flavour and aroma but also strips the oil of all its nutritive values. The more refined an oil is the less nourishing it will be for our bodies.\n\nNo heat or minimal heat was used for crushing/pressing the seeds and the process of production was simple without the addition of any solvent. The end product, thereby was qualitative with nutrients intact - making it ideal for cooking. A surefire way to do this right, would be to go the local, non-blended and chemical free route. And if this seems liked a lot of work- ask your grandmother! What they have been traditionally consuming before all the modernisation is the ideal choice.",
          "catalogType": "Product",
          "searchText": null,
          "productSearch": "organicgroundnutoilcoldpressed1litre",
          "currencySymbol": "₹",
          "status": "active",
          "unitOfMeasure": "Ltr",
          "commerceEnabled": "YES",
          "brand": "",
          "origin": "India",
          "categoryPath": "",
          "categoryCodePath": "",
          "hyperLocal": null,
          "businessResellerFlag": "y",
          "costboHsnCode": null,
          "offer": null,
          "preference": 1,
          "productOriginalPrice": 340.0,
          "productSalePrice": 310.0,
          "percentageOff": 9.0,
          "minOrderQuantity": 1.0,
          "maxOrderQuantity": 10.0,
          "availableQuantity": 729.0,
          "soldQuantity": 4614.0,
          "alertQuantity": 25.0,
          "shipmentDistance": 4000.0,
          "commerceStartDate": 1613932200000,
          "commerceEndDate": 1672425000000
      },
      "createdDate": 1646984938299
  },
  {
      "productId": "ee382488211b441e9e274096d12eab01",
      "name": "Palmyra Candy - 100 grams",
      "pic": "https://storage.googleapis.com/bo3151920215/business/186492f9a0fa41e29ab17dcc0ab3ba7f/product/ee382488211b441e9e274096d12eab01/Product3-813524.jpeg",
      "totalQuantity": 1,
      "item": {
          "id": "ee382488211b441e9e274096d12eab01",
          "productName": "Palmyra Candy - 100 grams",
          "productDescription": "Palmyra Candy - 100 grams",
          "catalogType": "Product",
          "searchText": null,
          "productSearch": "palmyracandy100grams",
          "currencySymbol": "₹",
          "status": "active",
          "unitOfMeasure": "Gram",
          "commerceEnabled": "YES",
          "brand": "Cape Comorian",
          "origin": "India",
          "categoryPath": "",
          "categoryCodePath": "",
          "hyperLocal": null,
          "businessResellerFlag": "y",
          "costboHsnCode": null,
          "offer": null,
          "preference": 0,
          "productOriginalPrice": 67.0,
          "productSalePrice": 67.0,
          "percentageOff": 0.0,
          "minOrderQuantity": 1.0,
          "maxOrderQuantity": 10.0,
          "availableQuantity": 998.0,
          "soldQuantity": 2.0,
          "alertQuantity": 25.0,
          "shipmentDistance": 4000.0,
          "commerceStartDate": 1633977000000,
          "commerceEndDate": 1760207400000
      },
      "createdDate": 1636438947693
  },
  {
      "productId": "f47e57dec40d4330ac961ad2a3fc9333",
      "name": "Organic Groundnut Oil - Cold pressed - 2 litres",
      "pic": "https://storage.googleapis.com/bo3151920215/business/186492f9a0fa41e29ab17dcc0ab3ba7f/product/f47e57dec40d4330ac961ad2a3fc9333/product1-iXGDQT.jpeg",
      "totalQuantity": 10,
      "item": {
          "id": "f47e57dec40d4330ac961ad2a3fc9333",
          "productName": "Organic Groundnut Oil - Cold pressed - 2 litres",
          "productDescription": "Best suited for daily cooking. \n\nMade from sun dried ground nuts, good source of plant sterols.\n\n* Cold pressed groundnut oil is rich in MUFA. It is free of trans fat. \n\n* Improves heart health\n\n* Rich in antioxidants, thereby protecting against cancer\n\n* Improves blood flow\n\n* Helps lowering high blood pressure\n\n* Help get rid of acne and blackheads\n\n\nIndustrial Extraction Vs Cold Pressed Oils\nExtraction by industrial methods, involves various processes like bleaching, steaming, distillation and hydrogenation - the seeds are exposed to extremely high temperatures to get clear bland oil and  chemicals like phosphoric acid, calcium hypo chlorite are added to increase the shelf life of the product which in turn affects  not only the flavour and aroma but also strips the oil of all its nutritive values. The more refined an oil is the less nourishing it will be for our bodies.\n\nNo heat or minimal heat was used for crushing/pressing the seeds and the process of production was simple without the addition of any solvent. The end product, thereby was qualitative with nutrients intact - making it ideal for cooking. A surefire way to do this right, would be to go the local, non-blended and chemical free route. And if this seems liked a lot of work- ask your grandmother! What they have been traditionally consuming before all the modernisation is the ideal choice.",
          "catalogType": "Product",
          "searchText": null,
          "productSearch": "organicgroundnutoilcoldpressed2litres",
          "currencySymbol": "₹",
          "status": "active",
          "unitOfMeasure": "Ltr",
          "commerceEnabled": "YES",
          "brand": "",
          "origin": "India",
          "categoryPath": "",
          "categoryCodePath": "",
          "hyperLocal": null,
          "businessResellerFlag": "y",
          "costboHsnCode": null,
          "offer": null,
          "preference": 2,
          "productOriginalPrice": 680.0,
          "productSalePrice": 600.0,
          "percentageOff": 12.0,
          "minOrderQuantity": 1.0,
          "maxOrderQuantity": 10.0,
          "availableQuantity": 215.0,
          "soldQuantity": 36.0,
          "alertQuantity": 25.0,
          "shipmentDistance": 4000.0,
          "commerceStartDate": 1613932200000,
          "commerceEndDate": 1672425000000
      },
      "createdDate": 1622433060352
  },
  {
      "productId": "fb49aa3d3f9e4eec8c70a3d32e20c6f3",
      "name": "Farm Honey - 250 ml",
      "pic": "https://storage.googleapis.com/bo3151920215/business/186492f9a0fa41e29ab17dcc0ab3ba7f/product/fb49aa3d3f9e4eec8c70a3d32e20c6f3/product1-TeGjfs.jpeg",
      "totalQuantity": 4,
      "item": {
          "id": "fb49aa3d3f9e4eec8c70a3d32e20c6f3",
          "productName": "Farm Honey - 250 ml",
          "productDescription": "• Local, raw honey has healing properties. Add it to your hot tea to soothe a sore throat, for instance. \n• Honey is a natural antibacterial and antimicrobial agent. Raw honey may have a soothing effect on digestion, helping with symptoms of diarrhea.",
          "catalogType": "Product",
          "searchText": null,
          "productSearch": "farmhoney250ml",
          "currencySymbol": "₹",
          "status": "active",
          "unitOfMeasure": "Gram",
          "commerceEnabled": "YES",
          "brand": "",
          "origin": "India",
          "categoryPath": "",
          "categoryCodePath": "",
          "hyperLocal": null,
          "businessResellerFlag": "y",
          "costboHsnCode": null,
          "offer": null,
          "preference": 27,
          "productOriginalPrice": 160.0,
          "productSalePrice": 155.0,
          "percentageOff": 3.0,
          "minOrderQuantity": 1.0,
          "maxOrderQuantity": 10.0,
          "availableQuantity": 247.0,
          "soldQuantity": 3.0,
          "alertQuantity": 25.0,
          "shipmentDistance": 4000.0,
          "commerceStartDate": 1561833000000,
          "commerceEndDate": 1672425000000
      },
      "createdDate": 1607487070023
  }
]

export const dummyCartProducts = [
  {
    quantity: 2,
    isDiscount: false,
    isOutOfStock: false,
  },
  {
    quantity: 4,
    isDiscount: true,
    isOutOfStock: true,
  },
  {
    quantity: 1,
    isDiscount: true,
    isOutOfStock: false,
  },
  {
    quantity: 6,
    isDiscount: true,
    isOutOfStock: true,
  },
  {
    quantity: 2,
    isDiscount: false,
    isOutOfStock: false,
  },
  {
    quantity: 1,
    isDiscount: true,
    isOutOfStock: true,
  },
  {
    quantity: 3,
    isDiscount: true,
    isOutOfStock: false,
  },
  {
    quantity: 6,
    isDiscount: true,
    isOutOfStock: false,
  },
];

export const discountData = [
  {
    codeValidityEnd: "Dec 21 2025",
    discountPercentage: "5",
    resellerCode: "SSVFOODS5",
  },
  {
    codeValidityEnd: "Dec 21 2025",
    discountPercentage: "5",
    resellerCode: "SSVFOODS5",
  },
  {
    codeValidityEnd: "Dec 21 2025",
    discountPercentage: "5",
    resellerCode: "SSVFOODS5",
  },
  {
    codeValidityEnd: "Dec 21 2025",
    discountPercentage: "5",
    resellerCode: "SSVFOODS5",
  },
];

export const mainProducts = [
  {
    productName: "Pusti milk 1",
  },
  {
    productName: "Pusti milk 2",
  },
  {
    productName: "Pusti milk 3",
  },
  {
    productName: "Pusti milk 4",
  },
  {
    productName: "Pusti milk 5",
  },
  {
    productName: "Pusti milk 6",
  },
  {
    productName: "Pusti milk 7",
  },
  {
    productName: "Pusti milk 8",
  },
];

export const productImages=[
  {
    img: "",
  },
  {
    img: "",
  },
  // {
  //   img: "",
  // },
  {
    img: "",
  },
  {
    img: "",
  },
]


export const addressData=[
  {
    name:"Viji (Home)",
    address:"195 Phase 1 Classic Orchards Layout Bannerghatta Road Bangalore,India.",
    phone:"8098081991"
  },
  {
    name:"Viji (Home)",
    address:"195 Phase 1 Classic Orchards Layout Bannerghatta Road Bangalore,India.",
    phone:"8098081991"
  },
  {
    name:"Viji (Home)",
    address:"195 Phase 1 Classic Orchards Layout Bannerghatta Road Bangalore,India.",
    phone:"8098081991"
  },
  {
    name:"Viji (Home)",
    address:"195 Phase 1 Classic Orchards Layout Bannerghatta Road Bangalore,India.",
    phone:"8098081991"
  },
  {
    name:"Viji (Home)",
    address:"195 Phase 1 Classic Orchards Layout Bannerghatta Road Bangalore,India.",
    phone:"8098081991"
  },
]
export const deliveryMethods = [
  {
    icon:'https://storage.googleapis.com/bodefaults/shopweb/delivery_rush.svg',
    title: "Rush",
    value: "rush",
    subtitle: "(0-2 days)",
    price: "₹240.00",
  },
  {
    icon:'https://storage.googleapis.com/bodefaults/shopweb/delivery_express.svg',
    title: "Express",
    value: "express",
    subtitle: "(2-4 days)",
    oldPrice: "120.00",
    price: "75.00",
  },
  {
    icon:'https://storage.googleapis.com/bodefaults/shopweb/delivery_standard.svg',
    title: "Standard",
    value: "standard",
    subtitle: "(1-2 days)",
    oldPrice: "170.00",
    price: "150.00",
  },
  {
    icon:'https://storage.googleapis.com/bodefaults/shopweb/delivery_regular_delivery.svg',
    title: "Regular Delivery",
    value: "regular-delivery",
    subtitle: "(2-5 days)",
    oldPrice: "140.00",
    price: "100.00",
  },
  {
    icon:'https://storage.googleapis.com/bodefaults/shopweb/delivery_costbo_premier.svg',
    title: "Costbo Premier",
    value: "costbo-premier",
    subtitle: "(1-3 days)",
    oldPrice: "120.00",
    price: "₹80.00",
  },
  {
    icon:'https://storage.googleapis.com/bodefaults/shopweb/delivery_instore_pickup.svg',
    title: "Instore Pickup",
    value: "instore-pickup",
    subtitle: "Open Hours",
    price: "₹00.00",
  },
  {
    icon:'https://storage.googleapis.com/bodefaults/shopweb/delivery_costbo_premier.svg',
    title: "Costbo Premier",
    value: "costbo-premier2",
    subtitle: "(1-3 days)",
    oldPrice: "120.00",
    price: "₹80.00",
  },
];

export const homeDiscounts=[
  {
    codeValidityEnd: new Date(),
    discountPercentage:'30',
    resellerCode:'GOFREE'
  },
  {
    codeValidityEnd: new Date(),
    discountPercentage:'25',
    resellerCode:'GOFREE'
  },
  {
    codeValidityEnd: new Date(),
    discountPercentage:'20',
    resellerCode:'GOFREE'
  },
  {
    codeValidityEnd: new Date(),
    discountPercentage:'10',
    resellerCode:'GOFREE'
  },
]